// @ts-nocheck
import { get } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768';
const BASE_URL = `${API_URL}/api/v1/Metabase`;
export const getMetabaseDashboardToken = async (dashboardId) => {
    const query = dashboardId ? `?dashboardId=${encodeURIComponent(String(dashboardId))}` : '';
    const response = await get(`${BASE_URL}/dashboard-token${query}`);
    return response?.data || response || {};
};
